import { FeaturePersonalDetailsTranslationDictionary } from '../models/i18n/feature-personal-details-dictionary.interface';

export const enUsTranslation: FeaturePersonalDetailsTranslationDictionary = {
  PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_EMAIL:
    'Please enter a valid email address',
  PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_MAX_LENGTH:
    'Please enter a value that is no more than {{ maxLength }} characters',
  PERSONAL_DETAILS_FORM_EMAIL_ADDRESS_ERROR_REQUIRED:
    'Please enter an email address',
  PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_ALPHABETICAL:
    'Please enter an alphabetical value',
  PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_MAX_LENGTH:
    'Please enter a value that is no more than {{ maxLength }} characters',
  PERSONAL_DETAILS_FORM_FIRST_NAME_ERROR_REQUIRED: 'Please enter a first name',
  PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_ALPHABETICAL:
    'Please enter an alphabetical value',
  PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_MAX_LENGTH:
    'Please enter a value that is no more than {{ maxLength }} characters',
  PERSONAL_DETAILS_FORM_LAST_NAME_ERROR_REQUIRED: 'Please enter a last name',
  PERSONAL_DETAILS_FORM_REQUIRED_FIELD_LEGEND: '* Required field',
  PERSONAL_DETAILS_FORM_SUBMIT_BUTTON: 'Continue',
  PERSONAL_DETAILS_FORM_TELEPHONE_NUMBER_ERROR_PATTERN:
    'Please enter a valid phone number',
  PERSONAL_DETAILS_FORM_TELEPHONE_NUMBER_ERROR_REQUIRED:
    'Please enter a telephone number',
  PERSONAL_DETAILS_FORM_TITLE_ID_ERROR_REQUIRED: 'Please select a title',
};
